module.exports = __webpack_public_path__ + "static/img/login-logo.83f75be6.png";